import { Spinner } from '@/components/common';
import { InstitutionDTO } from '@/models';
import React from 'react';

export interface InstitutionSelectorProps {
  institutions: InstitutionDTO[];
  selectedInstitutionId: string | null;
  onInstitutionChange: (institutionId: string | null) => void;
  disabled: boolean;
  isLoading: boolean;
}

export const InstitutionSelector: React.FC<InstitutionSelectorProps> = ({
  institutions,
  selectedInstitutionId,
  onInstitutionChange,
  disabled,
  isLoading,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onInstitutionChange(event.target.value || null);
  };

  return (
    <div className="col-md-6 col-lg-4">
      <label htmlFor="institutionSelect" className="form-label fw-semibold">
        Select Institution
      </label>
      {isLoading ? (
        <div className="form-control d-flex align-items-center">
          <Spinner size="sm" />
          <span className="ms-2">Loading institutions...</span>
        </div>
      ) : (
        <select
          id="institutionSelect"
          className="form-select"
          value={selectedInstitutionId || ''}
          onChange={handleChange}
          disabled={disabled}
        >
          <option value="">Select an institution...</option>
          {institutions.map((institution) => (
            <option key={institution.id} value={institution.id}>
              {institution.name || institution.id}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default InstitutionSelector;
